module.exports = __webpack_public_path__ + "img/logo.b12586f5.png";